'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getData();
  }

  getData() {
    this.$http.get('/api/tpFirmwares').then(res => {
      this.data = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/tpFirmwares/${id}`).then(res => {
        this.getData();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/tpFirmwares/list/list.controller.js